export const ampRulesMapping = {
  Path: "Pathways",
  Soma: "Somatic Evidence",
  Pubs: "Publications",
  Drug: "Drugs & Treatments",
  Type: "Variant Impact",
  Freq: "Allele Frequency",
  Germ: "Germline Evidence",
  Pred: "Predictions",
  Curd: "Curated Variants",
  Crtd: "Curated Variants",
};

export const SV_DUPLICATION = "duplication";
export const SV_DELETION = "deletion";
export const SV_TANDEM_DUPLICATION = "tandem duplication";
export const SV_INSERTION = "insertion";
export const SV_INVERSION = "inversion";
export const SV_BREAKEND = "breakend";
